<div class="container" @fadeInAnimation>

  <app-title title="ADMIN.I18N.LABEL"></app-title>

  <admin-i18n-selector
    [languages]="languages"
    [usedLanguage]="usedLanguage"
    [loading]="loading"
    [saving]="saving"
    (testLanguage)="testLanguage($event)"
    (editLanguage)="editLanguage($event)"
    (resetLanguages)="resetLanguages()"
    (editAllCsv)="editAllCsv()"
    (jsonSelected)="onJsonChanged($event)"
    (selectedJsonLanguage)="onChangeSelectedJsonLanguage($event)"
  ></admin-i18n-selector>

  <admin-i18n-csv-editor
    [csv]="csv"
    [valid]="errorMessage === null || errorMessage === undefined || errorMessage === ''"
    [errorMessage]="errorMessage"
    [edit]="edit"
    [loading]="loading"
    [saving]="saving"
    [enableSave]="dataChanged"
    (save)="save($event)"
    (changed)="contentChanged()"
    *ngIf="!jsonSelected"
  ></admin-i18n-csv-editor>

  <admin-i18n-json-editor
    [json]="json"
    [referenceJson]='referenceJson'
    [loading]="loading"
    [saving]="saving"
    [enableSave]="dataChanged"
    (save)="save($event)"
    (changed)="contentChanged()"
    *ngIf="jsonSelected && json"
  ></admin-i18n-json-editor>
</div>
